/*
 * <bh-timeslots> — renders a native <select>'s options as a vertical list of
 * selectable time-slot buttons (Cal.com-style). The native <select> stays in the
 * DOM (hidden) so it keeps submitting the form value and so the configurator can
 * keep repopulating its options (time slots change by date + delivery zone).
 *
 * Markup:
 *   <bh-timeslots data-empty="Изберете дата">
 *     <select id="TimeSlotSelect" name="…"> … </select>
 *   </bh-timeslots>
 */
class BhTimeslots extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    if (!this.select || this._built) return;
    this._built = true;
    this.emptyLabel = this.getAttribute('data-empty') || '';

    this.select.classList.add('bh-timeslots__native');
    this.select.setAttribute('tabindex', '-1');
    this.select.setAttribute('aria-hidden', 'true');

    this.list = document.createElement('div');
    this.list.className = 'bh-timeslots__list';
    this.list.setAttribute('role', 'radiogroup');
    const labelledby = this.select.getAttribute('aria-labelledby');
    if (labelledby) this.list.setAttribute('aria-labelledby', labelledby);
    this.appendChild(this.list);

    this._mo = new MutationObserver(() => { if (!this._suppress) this._render(); });
    this._mo.observe(this.select, { childList: true });
    this.select.addEventListener('change', () => { if (!this._suppress) this._render(); });

    this._render();
  }

  disconnectedCallback() { this._mo?.disconnect(); }

  _render() {
    const opts = [...this.select.options].filter(o => o.value !== '');
    this.list.innerHTML = '';
    if (!opts.length) {
      if (this.emptyLabel) {
        const empty = document.createElement('div');
        empty.className = 'bh-timeslots__empty';
        empty.textContent = this.emptyLabel;
        this.list.appendChild(empty);
      }
      return;
    }
    opts.forEach((o) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bh-timeslots__btn' + (o.selected ? ' is-selected' : '');
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', o.selected ? 'true' : 'false');
      btn.dataset.value = o.value;
      const dot = document.createElement('span');
      dot.className = 'bh-timeslots__dot';
      dot.setAttribute('aria-hidden', 'true');
      const label = document.createElement('span');
      label.textContent = o.textContent.trim();
      btn.appendChild(dot);
      btn.appendChild(label);
      btn.addEventListener('click', () => this._pick(o.value));
      this.list.appendChild(btn);
    });
  }

  _pick(value) {
    this._suppress = true;
    this.select.value = value;
    this.select.dispatchEvent(new Event('change', { bubbles: true }));
    this._suppress = false;
    this._render();
  }
}

if (!customElements.get('bh-timeslots')) customElements.define('bh-timeslots', BhTimeslots);
